import { render, staticRenderFns } from "./RiskAssessment.vue?vue&type=template&id=601c7238&scoped=true"
import script from "./RiskAssessment.vue?vue&type=script&lang=js"
export * from "./RiskAssessment.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessment.vue?vue&type=style&index=0&id=601c7238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c7238",
  null
  
)

export default component.exports